/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-closing-tag-location */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactMarkdown from 'react-markdown';
import {
    object, shape, string, arrayOf,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import * as app from '../../../../../../state/ducks/App';
import customBreakpoints from '../../../../../helpers/customBreakpoints';

const brandSelectors = app.ducks.brand.selectors;

const styles = (theme) => ({   // eslint-disable-line arrow-parens
    moreAbout: {
        maxWidth: '1440px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        outlineColor: theme.palette.grey8,
        '& h1': {
            fontSize: '27px',
            lineHeight: '40px',
            marginBottom: '0',
            paddingBottom: '20px',
            color: theme?.palette?.colorPrimary,
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '15px',
                lineHeight: '31px',
                paddingBottom: '0',
            },
        },
    },
    text: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '21px',
        padding: '15px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: theme.palette.sectionHeaderTextColor,
        [theme.breakpoints.down(600)]: {
            fontSize: '16px',
        },
    },
    morePlants: {
        maxWidth: '1440px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        outlineColor: theme.palette.grey8,
        '& h1': {
            fontSize: '1.25rem',
            fontFamily: 'Hind, sans-serif',
            fontWeight: 700,
            textAlign: 'center',
            color: '#000',
            marginBottom: '0',
            paddingBottom: '20px',
            marginTop: '2rem',
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '1.5rem',
                lineHeight: '1.5rem',
                paddingBottom: '0',
                color: '#87AA35',
                fontFamily: 'BebasNeue',
                fontWeight: '500',
                textAlign: 'left',
            },
        },
    },
    plusIcon: {
        height: '26px',
        marginBottom: '0',
        '&:hover': {
            textDecoration: 'none',
        },
        [theme.breakpoints.down(600)]: {
            height: '20px',
        },
    },
    seoContentContainer: {
        overflow: 'hidden',
        transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    },
    plaSeoContentContainer: {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '4rem',
        padding: '0 15px',
    },
    footerBody: {
        paddingLeft: '15px',
        paddingRight: '15px',
        fontSize: '14px',
        maxWidth: '1440px',
        margin: '0 auto',
        letterSpacing: '.03em',
        WebkitFontSmoothing: 'antialiased',
        marginBottom: '30px',
        '& h1, h2': {
            width: '100%',
            color: theme.palette.sectionHeaderTextColor,
            fontFamily: theme.typography.fontFamily,
            whiteSpace: 'normal',
        },
        '& h2': {
            fontSize: '14px',
            lineHeight: '16px',
            marginBottom: '0px',
            marginTop: '0',
            paddingBottom: '15px',
            color: theme.palette.black,
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '14px',
                lineHeight: '22px',
            },
            '& ul': {
                boxSizing: 'content-box',
            },
        },
        '& p': {
            fontSize: '12px',
            color: theme.palette?.footer?.description,
            lineHeight: '24px',
            margin: '5px 0',
            [theme.breakpoints.down(600)]: {
                paddingBottom: '30px',
            },
        },
        '& a': {
            color: theme.palette.colorPrimary,
            fontWeight: 'bold',
            textDecoration: 'none',
        },
        '& ul': {
            lineHeight: '1.5',
            color: theme.palette.sectionHeaderTextColor,
        },
        '& > div': {
            width: 'calc(100% + 100px)',
            marginLeft: '-50px !important',
            marginRight: '-50px !important',
            marginTop: '20px !important',
            '& > div': {
                paddingLeft: '50px !important',
                paddingRight: '50px !important',
                paddingBottom: '0 !important',
                paddingTop: '0 !important',
                '&.MuiGrid-item': {
                    [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                        padding: '0 16px',
                    },
                },
                '&:nth-child(2)': {
                    [theme.breakpoints.up(customBreakpoints.tabPortrait)]: {
                        borderLeft: `1px solid ${theme.palette.black}`,
                        borderRight: `1px solid ${theme.palette.black}`,
                    },
                },
            },
        },
    },
    dividerMatch: {
        paddingBottom: '20px',
    },
    plantsDividerMatch: {
        paddingBottom: '10px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            display: 'none',
        },
    },
    plantsStyleH2: {
        paddingLeft: '15px',
        paddingRight: '15px',
        fontSize: '14px',
        maxWidth: '1270px',
        margin: '0 auto',
        letterSpacing: '.03em',
        WebkitFontSmoothing: 'antialiased',
        textAlign: 'center',
        marginBottom: '30px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            textAlign: 'left',
            paddingLeft: '0px !important',
            paddingRight: '0px !important',
        },
        '& h1, h2': {
            width: '100%',
            color: theme.palette.sectionHeaderTextColor,
            fontFamily: theme.typography.fontFamily,
            whiteSpace: 'normal',
        },
        '& h2': {
            margin: '0.75rem 0 0',
            marginBottom: '0.25rem',
            fontSize: '1rem',
            fontWeight: 700,
            lineHeight: 1.5,
            paddingBottom: '5px',
            color: theme.palette.black,
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                fontSize: '14px',
                lineHeight: '22px',
            },
            '& ul': {
                boxSizing: 'content-box',
            },
        },
        '& p': {
            fontSize: '0.8125rem',
            color: theme.palette?.footer?.copyright,
            lineHeight: '1.5',
            margin: '0',
            fontWeight: 400,
            [theme.breakpoints.down(600)]: {
                paddingBottom: '0px !important',
            },
        },
        '& a': {
            color: theme.palette.linkColor,
            fontWeight: 'bold',
            textDecoration: 'underline',
        },
        '& ul': {
            lineHeight: '1.5',
            color: theme.palette.sectionHeaderTextColor,
        },
        '& .MuiGrid-container': {
            [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                width: 'auto',
                margin: '0',
                '&:last-child': {
                    marginBottom: '25px',
                },
            },
        },
        '& > div': {
            marginTop: '8px !important',
            '& > div': {
                marginBottom: '1rem',
                marginTop: '1rem',
                paddingLeft: '15px',
                paddingRight: '15px',
                paddingBottom: '0 !important',
                paddingTop: '0 !important',
                [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                    padding: '0px',
                },
                '&.MuiGrid-item': {
                    '& hr': {
                        display: 'none',
                    },
                    '& img': {
                        display: 'none',
                    },
                    [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
                        paddingRight: '0',
                        paddingLeft: '0',
                        marginTop: '0',
                        marginBottom: '0',
                        position: 'relative',
                        '& hr': {
                            display: 'block',
                            borderBottom: '1px solid #000',
                            paddingTop: '25px',
                            borderRightWidth: '0',
                            borderTopWidth: '0',
                            borderLeftWidth: '0',
                            width: '90%',
                        },
                        '& img': {
                            display: 'block',
                            height: '55px',
                            width: '55px',
                            backgroundColor: '#F2F2F2',
                            position: 'absolute',
                            left: '43%',
                            top: '83%',
                        },
                    },
                },
                '&:nth-child(2)': {
                    [theme.breakpoints.up(customBreakpoints.tabPortrait)]: {
                        borderLeft: `1px solid ${theme.palette.black}`,
                        borderRight: `1px solid ${theme.palette.black}`,
                    },
                },
                '&:last-child': {
                    [theme.breakpoints.up(customBreakpoints.tabPortrait)]: {
                        borderRight: 'none !important',
                    },
                },
            },
        },
    },
    footerSeoDivider: {
        position: 'relative',
        textAlign: 'center',
        marginTop: '20px',
        marginBottom: '40px',
        [theme.breakpoints.down(600)]: {
            marginBottom: '20px',
        },
        '& hr': {
            maxWidth: '1400px',
            borderBottom: `1px solid ${theme.palette.colorPrimary}`,
            width: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: '0',
            padding: '0',
            margin: '0 auto',
            borderTop: '0',
        },
        '& img': {
            backgroundColor: theme.palette.desktopBgFooter,
            zIndex: '1',
            position: 'relative',
            padding: '0 10px',
            width: '50px',
        },
    },
    footerPlantSeoDivider: {
        position: 'relative',
        textAlign: 'center',
        marginTop: '20px',
        marginBottom: '40px',
        [theme.breakpoints.down(600)]: {
            marginBottom: '20px',
        },
        '& hr': {
            backgroundSize: '5px 5px',
            backgroundImage: 'linear-gradient(to right, #000 30%, rgba(255,255,255,0) 0%)',
            borderTop: '1px solid rgba(0,0,0,.1)',
            backgroundRepeat: 'repeat-x',
            backgroundPosition: 'bottom',
            maxWidth: '1400px',
            width: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: '0',
            padding: '0',
            margin: '0 auto',
        },
        '& img': {
            backgroundColor: theme.palette.desktopBgFooter,
            zIndex: '1',
            position: 'relative',
            padding: '0 10px',
            width: '50px',
        },
    },
    footerFaqSection: {
        maxWidth: '1270px',
        margin: '0 auto',
        padding: '0 15px',
        color: '#000',
        [theme.breakpoints.down('1264')]: {
            maxWidth: '960px',
        },
        [theme.breakpoints.down('992')]: {
            maxWidth: '720px',
        },
        [theme.breakpoints.down('768')]: {
            maxWidth: '540px',
        },
        '& p': {
            margin: '0.75rem 0 0',
            fontSize: '1rem',
            fontWeight: 700,
            lineHeight: 1.5,
            paddingBottom: '5px',
        },
        '& ul': {
            marginTop: 0,
            marginBottom: '1rem',
            '& li': {
                listStyle: 'none',
                fontSize: '0.875rem',
                color: '#2e2c2c',
                '& a': {
                    fontSize: '0.8.125rem',
                    fontWeight: 'bolder',
                    textTransform: 'capitalize',
                    letterSpacing: '0.5px',
                    textDecoration: 'none',
                    color: '#000',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                },
            },
        },
    },
});

class GraphqlSeoFooter extends Component {
    constructor(props) {
        super(props);
        const { data: { default_state } } = this.props;
        this.heightRef = React.createRef();
        this.transEnd = React.createRef();
        this.state = {
            isExpanded: default_state === 'Expanded',
            divHeight: 'auto',
        };
    }

    componentDidUpdate() {
        if (this.transEnd?.current) {
            this.transEnd.current.addEventListener('transitionend', () => {
                // after height transition set to auto for responsiveness
                this.transEnd.current.style.height = 'auto';
            });
        }
    }

    showMoreText = () => {
        const { isExpanded } = this.state;
        this.setState({
            isExpanded: !isExpanded,
            divHeight: this.heightRef.current.clientHeight, // get hieght of div
        });
    }

    render() {
        const { isExpanded, divHeight } = this.state;
        const {
            classes, data: { group, title, file }, brand,
        } = this.props;
        const currentHeight = isExpanded ? divHeight : 0;
        if (!group.length || !title) return null;
        if (brand?.code === 'PLA' && title === 'FAQs') {
            return (
                <div className={classes.footerFaqSection}>
                    {group?.map((faq) => (
                        <ReactMarkdown
                            source={faq?.copy}
                            skipHtml
                        />
                    ))}
                </div>
            );
        }
        return (
            <>
                <div
                    className={brand?.code === 'PLA' ? classes.plaSeoContentContainer : classes.seoContentContainer}
                    style={{ height: `${currentHeight}px` }}
                    ref={this.transEnd}
                >
                    <div className={brand?.code === 'PLA' ? classes.footerPlantSeoDivider : classes.footerSeoDivider}>
                        <hr />
                        {file && <img src={file?.url} alt={file.filename} />}
                    </div>
                    <div
                        className={brand?.code === 'PLA' ? classes.morePlants : `${classes.moreAbout} ${classes.footerBody}`}
                    >
                        <Grid container>
                            <Grid item xs={12}>
                                <div>
                                    { brand?.code === 'CAN' ? <ReactMarkdown source={title} skipHtml /> : null }
                                    { brand?.code === 'PLA' ? <h1 className="plants-title">{title}</h1> : null }
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={brand?.code === 'PLA' ? `${classes.plantsStyleH2}` : `${classes.footerBody}`} ref={this.heightRef}>
                        { brand?.code === 'CAN' ? (
                            <>
                                <Grid container spacing={5}>
                                    {group.map((data) => (
                                        <Grid item xs={12} sm={4} key={data.heading} className={classes.footerSeoBody}>
                                            <div>
                                                <ReactMarkdown
                                                    source={data.heading}
                                                    skipHtml
                                                />
                                                <ReactMarkdown
                                                    source={data.copy}
                                                    skipHtml
                                                />
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>) : null }
                        { brand?.code === 'PLA' ? (
                            <>
                                <Grid container spacing={3} className="grid-container">
                                    {group.map((data, i) => (
                                        (i < 3)
                                        && <Grid item xs={12} sm={4} key={data.heading} className={classes.footerSeoBody}>
                                            <div>
                                                <ReactMarkdown
                                                    source={data.heading}
                                                    skipHtml
                                                />
                                                <ReactMarkdown
                                                    source={data.copy}
                                                    skipHtml
                                                />
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                                <div className={brand?.code === 'PLA' ? classes.plantsDividerMatch : classes.dividerMatch}>
                                    {group.map((data, i) => (
                                        (data && i === 3) && <div className={classes.footerPlantSeoDivider}> <hr /> </div>
                                    ))}
                                </div>
                                <Grid container spacing={5} justifyContent="center">
                                    {group.map((data, i) => (
                                        (i >= 3)
                                        && <Grid item xs={12} sm={4} key={data.heading} className={classes.footerSeoBody}>
                                            <div>
                                                <ReactMarkdown
                                                    source={data.heading}
                                                    skipHtml
                                                />
                                                <ReactMarkdown
                                                    source={data.copy}
                                                    skipHtml
                                                />
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>) : null }
                    </div>
                </div>
            </>
        );
    }
}

GraphqlSeoFooter.propTypes = {
    classes: object.isRequired,
    brand: object.isRequired,
    data: shape({
        group: arrayOf(shape({
            heading: string,
            copy: string,
        }).isRequired),
        title: string.isRequired,
        file: shape({
            filename: string,
            url: string,
        }),
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
});

export default connect(mapStateToProps)(withStyles(styles)(GraphqlSeoFooter));
